import { Box, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { FileIcon } from "lucide-react";
import { MediaUrl } from "../../../utils/configuration";
import { StationCameraItem } from "../../../models/types/stationCamera";
import DialogIframe from "../../dialog-iframe";
import { PlayIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";

// --- utils
import { convertToThumbnailUrl } from "../../../utils/helper";
import { useIntervalRerender } from "../../../hooks/useIntervalRerender";

const StationCamera = ({ data, editUrl, defaultOpen }: { data: StationCameraItem[]; editUrl: string; defaultOpen?: boolean }) => {
    const refreshKey = useIntervalRerender(30000);

    const [open, setOpen] = useState<boolean>(defaultOpen || false);
    const [selectedCamera, setSelectedCamera] = useState<StationCameraItem | null>(null);

    return (
        <div className="bg-white rounded-md">
            <Box sx={{ borderRadius: 1, border: "1px solid #cce4ff" }}>
                <Box
                    className="summary_header"
                    sx={{
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                    onClick={() => setOpen(!open)}
                >
                    <Typography fontWeight="bold">Camera</Typography>
                    <div className="flex items-center gap-2">
                        <Link
                            to={editUrl}
                            className="flex items-center gap-1 italic text-blue-500 text-sm hover:underline"
                        >
                            <Pencil size={12} />
                            Sửa
                        </Link>
                        <IconButton size="small">
                            <ExpandMoreIcon
                                sx={{
                                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                }}
                            />
                        </IconButton>
                    </div>
                </Box>
                <Collapse in={open}>
                    <Box className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-2" sx={{ p: 2 }}>
                        {data.length > 0 ? data.map((camera, index) => (
                            <div key={index} className="col-span-1">
                                <h3 className="font-semibold mb-2">{camera.title}</h3>
                                <div className="camera_thumbnail" onClick={() => setSelectedCamera(camera)}>
                                    <img className="w-full h-full"
                                        src={convertToThumbnailUrl(camera.cameraUrl) + `?t=${refreshKey}`}
                                        alt={camera.title}
                                        onError={(e) => {
                                            e.currentTarget.src = '/assets/images/no-image.png';
                                        }}
                                    />
                                    <div className="camera_thumbnail_overlay">
                                        <PlayIcon color="white" size={24} />
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <p className="text-center">Không có camera</p>
                        )}
                    </Box>
                </Collapse>
            </Box>
            <DialogIframe
                isOpen={!!selectedCamera}
                onClose={() => setSelectedCamera(null)}
                camera={selectedCamera}
            />
        </div>
    );
};

export default StationCamera;